export const NEEDS = [
  { id: "more-leads", label: "Get more leads", draft: "My team spends hours following up with leads, and some go cold before we reply." },
  { id: "team-time", label: "Less wasted team time", draft: "My team loses hours every week on repetitive manual work." },
  { id: "operating-costs", label: "Reduce operating costs", draft: "I want to reduce our operating costs without lowering the quality of our service." },
  { id: "admin-accounting", label: "Simplify admin or accounting", draft: "I want to simplify invoices, admin and accounting tasks." },
  { id: "customer-service", label: "Better customer service", draft: "Customers wait too long for answers, and my team is stretched." },
  { id: "automate-process", label: "Automate a process", draft: "We have a manual process I’d like to automate from start to finish." },
  { id: "build-with-ai", label: "Build something with AI", draft: "I have an idea for something we could build with AI, but I don’t know where to start." },
  { id: "donor-engagement", label: "Automate donor engagement", draft: "I want to automate donor follow-up and engagement while keeping communications personal." },
  { id: "unsure", label: "Not sure where AI can help", draft: "I’m not sure where AI can help my organization. Help me identify useful opportunities." },
];

export const QUESTIONS = [
  {
    id: "successful-outcome",
    prompt: "What would a successful outcome look like for your organization?",
    helper: "Describe it in your own words — what would be different, easier or no longer necessary.",
    placeholder: "e.g. Every new enquiry gets a reply the same day without someone chasing it.",
  },
];

export const labelForNeed = (id) => NEEDS.find((n) => n.id === id)?.label ?? id;

export const EXAMPLES = [
  "My team spends hours following up with leads.",
  "I want to automate invoices and admin tasks.",
  "Customers wait too long for answers.",
  "Our tools don’t share information.",
  "I have an idea for an AI agent but don’t know where to start.",
];
